import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { loadAllDesignation } from "../../../redux/rtk/features/designation/designationSlice";
import { loadAllEmploymentStatus } from "../../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import { loadAllLeavePolicy } from "../../../redux/rtk/features/leavePolicy/leavePolicySlice";
import { getAllNoticePeriod } from "../../../redux/rtk/features/masters/noticePeriodSlice";
import { getAllPaymentType } from "../../../redux/rtk/features/masters/paymentTypeSlice";
import { loadAllShift } from "../../../redux/rtk/features/shift/shiftSlice";
import { getCompanyNameByClientId, loadAllStaff, loadSingleStaff, updateUser } from "../../../redux/rtk/features/user/userSlice";
import { loadAllWeeklyHoliday } from "../../../redux/rtk/features/weeklyHoliday/weeklyHolidaySlice";
import getCompanyIdFromToken from "../../../utils/getCompanyIdFromToken";
import getPermissions from "../../../utils/getPermissions";
import { getDepartments } from "../../department/departmentApis";
import { getRoles } from "../../role/roleApis";
import BtnEditSvg from "../Button/btnEditSvg";
import getSetting from "../../../api/getSettings";


const EmployeeEditPopup = ({ userId, user }) => {
    const Option = Select
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { id } = useParams();
    const permissions = getPermissions();
    const hasPermission = (item) => {
        return permissions?.includes(item ? item : "");
    };
    // Selectors
    const users = useSelector((state) => state.users?.list);
    const officeName = useSelector((state) => state.users?.companyName);
    const paymentType = useSelector((state) => state.paymentType?.list);
    const weeklyHoliday = useSelector((state) => state.weeklyHoliday?.list);
    const employmentStatus = useSelector((state) => state.employmentStatus?.list);
    const shift = useSelector((state) => state.shift?.list);
    const departmentList = useSelector((state) => state.department?.list);
    const designation = useSelector((state) => state.designations?.list);
    const noticePeriod = useSelector((state) => state.noticePeriod?.list);
    const [rolesList, setRolesList] = useState(null);
    const [departmentsList, setDepartmentsList] = useState(null);
    const [companyNames, setCompanyNames] = useState([]);


    // Load initial data
    useEffect(() => {
        dispatch(loadAllDesignation());
        dispatch(loadAllEmploymentStatus());
        dispatch(loadAllShift());
        dispatch(loadAllWeeklyHoliday());
        dispatch(getAllPaymentType());
        dispatch(loadAllLeavePolicy());
        dispatch(loadAllStaff({ status: true }));
        dispatch(getAllNoticePeriod())
    }, [dispatch]);

    // Load roles
    useEffect(() => {
        getRoles()
            .then((data) => setRolesList(data))
            .catch((error) => console.log("Error loading roles:", error));
    }, []);

    // Load departments
    useEffect(() => {
        getDepartments()
            .then((data) => setDepartmentsList(data))
            .catch((error) => console.log("Error loading departments:", error));
    }, []);

    // Prefill form data when modal opens
    useEffect(() => {
        if (isModalOpen && user) {
            console.log('Setting form values with user data:', user);
            form.resetFields();
            form.setFieldsValue({
                employeeId: user?.employeeId || "",
                officialMailId: user?.officialMailId || "",
                probationPeriod: user?.probationPeriod ? dayjs(user?.probationPeriod, "YYYY-MM-DD") : null,
                joinDate: user?.joinDate ? dayjs(user?.joinDate, "YYYY-MM-DD") : null,
                esic: user?.esic || "",
                uan: user?.uan || "",
                employmentStatusId: user?.employmentStatusId || "",
                departmentId: user?.departmentId || "",
                reportingManagerId: user?.reportingManagerId || "",
                roleId: user?.roleId || "",
                shiftId: user?.shiftId || "",
                weeklyHolidayId: user?.weeklyHolidayId || "",
                pfEligiblity: user?.pfEligiblity === true ? "yes" : "no",
                CompanyOfficeId: user?.CompanyOfficeId || "",
                noticePeriodId: user?.noticePeriodId || "",
                paymentType: user?.tbl_paymentType?.[0]?.paymentType || "",
                medicalInfo: user?.medicalInfo || ""
            });
        }
    }, [isModalOpen, user, form]);

    const companyId = getCompanyIdFromToken();
    console.log("companyId", companyId);
    // Dispatch action to fetch company names
    useEffect(() => {
        dispatch(getCompanyNameByClientId(companyId));
    }, [dispatch]);

    // Debug logging for user data
    useEffect(() => {
        if (user) {
            console.log('Current user data:', user);
        }
    }, [user]);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const onFinish = async (values) => {
        const updatedValues = {
            ...values,
            //   pfEligiblity: values.pfEligiblity === "Eligible"
            pfEligiblity: values.pfEligiblity === "yes" ? true : false,
            joinDate: values.joinDate ? dayjs(values.joinDate).format("YYYY-MM-DD") : null,
            probationPeriod: values.probationPeriod ? dayjs(values.probationPeriod).format("YYYY-MM-DD") : null,
        };

        try {
            const response = await dispatch(updateUser({ id: userId, values: updatedValues }));
            if (response.payload.message === "success") {
                dispatch(loadSingleStaff(id));
                setIsModalOpen(false);
                form.resetFields();
            }
        } catch (error) {
            console.error("Error updating employee details:", error);
        }
    };

    useEffect(() => {
        const fetchCompanyNames = async () => {
            try {
                const response = await getSetting();
                console.log("API Response:", response);

                if (response && Array.isArray(response.result)) {
                    setCompanyNames(response.result);
                } else {
                    console.error("API response is not an array:", response);
                    setCompanyNames([]);
                }
            } catch (error) {
                console.error("Error fetching company names:", error);
                setCompanyNames([]);
            }
        };

        fetchCompanyNames();
    }, []);

    return (
        <>
            <button onClick={showModal}>
                <BtnEditSvg size={30} />
            </button>
            <Modal
                title="Update Employee Details"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    name="employeeDetails"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        rules={[{ required: true, message: "Please select a company!" }]}
                        label="Company"
                        name="CompanyOfficeId"
                        style={{ marginBottom: "10px" }}
                    >
                        <Select
                            style={{ width: "100%" }}
                            placeholder="Please select company"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                option?.children?.toLowerCase()?.includes(input.toLowerCase())
                            }
                        >
                            {(companyNames || []).map((company) => (
                                <Option key={company.id} value={company.id}>
                                    {company.company_name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Employee ID"
                        name="employeeId"
                        rules={[{ required: true, message: "Please enter the employee ID!" }]}
                    >
                        <Input placeholder="Enter employee ID" />
                    </Form.Item>

                    <Form.Item
                        label="Official Email ID"
                        name="officialMailId"
                    // rules={[{ required: true, message: "Please enter the official email!" }]}
                    >
                        <Input placeholder="Enter official email" />
                    </Form.Item>

                    <Form.Item
                        style={{ marginBottom: "10px" }}
                        label='Joining Date'
                        name='joinDate'
                        rules={[
                            {
                                required: true,
                                message: "Please input joining date!",
                            },
                        ]}>
                        <DatePicker
                            className='date-picker hr-staffs-date-picker'

                            format="YYYY-MM-DD"
                            inputReadOnly
                        />
                    </Form.Item>
                    <Form.Item
                        style={{ marginBottom: "10px" }}
                        label='Probation Period'
                        name='probationPeriod'
                    >
                        <DatePicker
                            className='date-picker hr-staffs-date-picker'

                            format="YYYY-MM-DD"
                            inputReadOnly
                        />
                    </Form.Item>

                    <Form.Item
                        name="employmentStatusId"
                        label="Employment Status"
                        rules={[{ required: true, message: "Please select employment status!" }]}
                    >
                        <Select
                            placeholder="Select Status"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {employmentStatus?.map((status) => (
                                <Select.Option key={status.id} value={status.id}>
                                    {status.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="departmentId"
                        label="Department"
                        rules={[{ required: true, message: "Please select department!" }]}
                    >
                        <Select
                            loading={!departmentsList}
                            placeholder="Select Department"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {departmentsList?.map((department) => (
                                <Select.Option key={department.id} value={department.id}>
                                    {department.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Reporting Manager"
                        name="reportingManagerId"
                    // rules={[{ required: true, message: "Please select a reporting manager!" }]}
                    >
                        <Select
                            placeholder="Select reporting manager"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {users?.map((user) => (
                                <Select.Option key={user.id} value={user.id}>
                                    {`${user.firstName} ${user.lastName}`}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="roleId"
                        label="Role"
                        rules={[
                            { required: hasPermission('update-role'), message: "Please select user role!" }
                        ]}
                    >
                        <Select
                            loading={!rolesList}
                            placeholder={hasPermission('update-role') ? "Select Role" : "You don't have permission to update"}
                            showSearch
                            allowClear
                            disabled={!hasPermission('update-role')} // Disable the field if no permission
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {rolesList?.map((role) => (
                                <Select.Option key={role.id} value={role.id}>
                                    {role.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>


                    {/* <Form.Item
                        name="roleId"
                        label="Role"
                        rules={[{ required: true, message: "Please select user role!" }]}
                    >
                        <Select
                            loading={!rolesList}
                            placeholder="Select Role"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {rolesList?.map((role) => (
                                <Select.Option key={role.id} value={role.id}>
                                    {role.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item> */}
                    {/* <Form.Item
                        name="CompanyOfficeId"
                        style={{ marginBottom: "10px" }}
                        label="Office"
                        rules={[
                            { required: true, message: "Please Select Office!" },
                        ]}

                    >
                        <Select
                            loading={!officeName}
                            placeholder="Select Office"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                            size="middle"
                        >
                            {officeName &&
                                officeName.map((office) => (
                                    <Select.Option key={office.id} value={office.id}>
                                        {office.company_name}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Form.Item> */}

                    <Form.Item
                        label="Shift"
                        name="shiftId"
                    >
                        <Select
                            placeholder="Select shift"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {shift?.map((shiftItem) => (
                                <Select.Option key={shiftItem.id} value={shiftItem.id}>
                                    {shiftItem.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Weekly Off"
                        name="weeklyHolidayId"
                    >
                        <Select
                            placeholder="Select weekly holiday"
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {weeklyHoliday?.map((holiday) => (
                                <Select.Option key={holiday.id} value={holiday.id}>
                                    {holiday.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name={"noticePeriodId"}
                        style={{ marginBottom: "10px" }}
                        label='Notice Period'
                    >
                        <Select
                            loading={!noticePeriod}
                            placeholder='Select Notice Period'
                            showSearch allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }>
                            {noticePeriod &&
                                noticePeriod.map((noticePeriod) => (
                                    <Option key={noticePeriod.id} value={noticePeriod.id}>
                                        {noticePeriod.noticePeriod}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Pension"
                        name="pfEligiblity"
                        rules={[{ required: true, message: "Please select Pension!" }]}
                    >
                        <Select placeholder="Select Pension">
                            {/* <Select.Option value="Eligible">Eligible</Select.Option>
                            <Select.Option value="NotEligible">Not Eligible</Select.Option> */}
                            <Select.Option value="yes">Opt in</Select.Option>
                            <Select.Option value="no">Opt out</Select.Option>
                        </Select>
                    </Form.Item>


                    <Form.Item
                        style={{ marginBottom: "10px" }}
                        label="Payment Type"
                        name="paymentType"
                        rules={[{ required: true, message: "Please select Payment Type!" }]}
                    >
                        <Select
                            placeholder="Select Payment Type"
                            showSearch
                            allowClear
                            mode="combobox"
                        >
                            {paymentType &&
                                paymentType.map((paymentType) => (
                                    <Option key={paymentType.id} value={paymentType.id}>
                                        {paymentType.paymentType}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Medical information"
                        name="medicalInfo"
                    // rules={[{ required: true, message: "Please enter the official email!" }]}
                    >
                        <TextArea placeholder="Enter medical information" />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default EmployeeEditPopup;